export default {
    MAIN:       'main',
    NOW:        'now',
    SOON:       'soon',
    STRIPE:     'customStripes',
    SLIDER:     'customSliders',
    HIGHLIGHT:  'customHighlights',
    SHOWTIMES:  'showtimes',
    ADVERTISEMENT:  'advertisement',
}